import React from 'react';
import { StyleSheet, View } from 'react-native';
import LinearGradient from 'utils/packages/linearGradient';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import ContactItem from 'features/contacts/components/Contact';
import { CARD_VIEW_BORDER_RADIUS, CardView, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { SELECTED_ITEM_HEIGHT } from 'features/contacts/constants';
const strings = {
    title: 'Add members to your\nUltimate plan?',
    subtitle: {
        youAreAdding: (to) => `You’re adding members to your ${to}.`,
        includeThem: 'Would you like to also include them in your Ultimate plan so they can enjoy all premium features?',
        upgrade: 'Upgrade to “Ultimate” and add them as extra members so they get all the benefits.',
    },
    addBtn: 'Add members to plan',
    laterBtn: 'Later',
    upgradeBtn: 'Upgrade to Ultimate',
    extraMemberLabel: 'Extra member',
};
const MAX_NUM_OF_CONTACTS_SHOWN = 4;
const OverflowedItems = ({ item }) => {
    const styles = useStyles(styleSet);
    if (!item)
        return null;
    const bgColor = styles.potentialExtraMembers.backgroundColor;
    const { contact, isExtraMember } = item;
    return (<View style={styles.omittedItem}>
      <ContactItem contact={contact}>
        {isExtraMember === true ? (<Text Text-14 Secondary right>
            {strings.extraMemberLabel}
          </Text>) : null}
      </ContactItem>
      <LinearGradient colors={[`${bgColor}00`, bgColor]} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1 }} style={StyleSheet.absoluteFill}/>
    </View>);
};
const ModalRichContent = React.memo(({ needUpgrade, wasAddingToDisplayName, contacts }) => {
    const styles = useStyles(styleSet);
    const subtitle = [
        strings.subtitle.youAreAdding(wasAddingToDisplayName),
        needUpgrade ? strings.subtitle.upgrade : strings.subtitle.includeThem,
    ].join(' ');
    return (<View>
        <Text TextThin-14 Secondary centered>
          {subtitle}
        </Text>
        <Spacer.H16 />
        <CardView noMargin style={styles.potentialExtraMembers}>
          {contacts
            .slice(0, MAX_NUM_OF_CONTACTS_SHOWN)
            .map(({ contact, isExtraMember }, index) => (<ContactItem contact={contact} key={index}>
                {isExtraMember === true ? (<Text Text-14 Secondary right>
                    {strings.extraMemberLabel}
                  </Text>) : null}
              </ContactItem>))}
          <OverflowedItems item={contacts[MAX_NUM_OF_CONTACTS_SHOWN]}/>
        </CardView>
      </View>);
});
ModalRichContent.displayName = 'ModalRichContent';
export function showAddExtraMembersModal({ onConfirm, wasAddingToDisplayName, contacts, needUpgrade, }) {
    Modal.showConfirmation({
        title: strings.title,
        subtitle: (<ModalRichContent needUpgrade={needUpgrade} wasAddingToDisplayName={wasAddingToDisplayName} contacts={contacts}/>),
        cancelButtonTitle: needUpgrade ? strings.upgradeBtn : strings.addBtn,
        confirmButtonTitle: strings.laterBtn,
        onPressCancel: onConfirm,
    });
}
const styleSet = createStyleSheets((colors) => ({
    potentialExtraMembers: {
        backgroundColor: colors.background.dark,
    },
    omittedItem: {
        height: SELECTED_ITEM_HEIGHT * 0.6,
        overflow: 'hidden',
        borderBottomLeftRadius: CARD_VIEW_BORDER_RADIUS,
        borderBottomRightRadius: CARD_VIEW_BORDER_RADIUS,
    },
}));
